export { default } from './SkeletonBusDirectoryMapMobile';
